import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import { layoutComponentDefaultProps, layoutComponentPropTypes, LayoutContainer } from "./LayoutContainer";
export var OneToOneColumnLayout = function (props) {
  var children = props.children;
  return React.createElement(LayoutContainer, _extends({}, props, {
    columns: ["minmax(0, 1fr)", "minmax(0, 1fr)"]
  }), children);
};
OneToOneColumnLayout.propTypes = _objectSpread({}, layoutComponentPropTypes), OneToOneColumnLayout.defaultProps = _objectSpread({}, layoutComponentDefaultProps), OneToOneColumnLayout.__docgenInfo = {
  description: "Renders a two half width columns layout with flex inside and Card as a container by default\n\n@metadataType layout",
  methods: [],
  displayName: "OneToOneColumnLayout",
  composes: ["./LayoutContainer"]
}, OneToOneColumnLayout.__docgenInfo = {
  componentName: "OneToOneColumnLayout",
  packageName: "@jutro/components",
  description: "Renders a two half width columns layout with flex inside and Card as a container by default",
  displayName: "OneToOneColumnLayout",
  methods: [],
  actualName: "OneToOneColumnLayout",
  metadataType: "layout",
  composes: ["./LayoutContainer"]
};